import { useCallback } from "react";
import { useAuthStore } from "../store/useAuthStore";
import { useGameStore } from "../store/useGameStore";
import { authStorage, prefStorage } from "../utils/storage";
import { launchGame } from "../services/gameService";
import { showError } from "../utils/toast";

const SPORTS_GAME_UID = "92b24e4c25107367a80e0fe1a97c24e4";

export function useSportsLaunch() {
  const { isAuthenticated } = useAuthStore();

  return useCallback(async (e) => {
    if (e) e.preventDefault();

    if (!isAuthenticated) {
      showError("Please login to play Sports");
      return;
    }

    const currency = prefStorage.getCurrency() || "INR";
    const userId = authStorage.getUserId();
    const credits = localStorage.getItem("credit") || "0";

    useGameStore.getState().setGameLoading(true);
    useGameStore.getState().launchGame(null, true);

    const url = await launchGame(SPORTS_GAME_UID, userId, currency);

    if (url) {
      useGameStore.getState().launchGame(url, true);
    } else {
      useGameStore.getState().closeGame();
      showError("Sports is currently unavailable");
    }
  }, [isAuthenticated]);
}
